const SignaturePreview = ({ signature }) => {
  return (
    <div
      style={{
        // border: "1px solid var(--primary-25)",
        padding: "5px",
        // backgroundColor: "white",
        // fontFamily: "Arial, sans-serif",
        fontSize: "14px",
        // maxWidth: "500px",
      }}
    >
      {/* Logo */}
      {signature.logoType !== "none" && (
        <div style={{ marginBottom: "5px" }}>
          {signature?.logoURL !== null && (
            <img
              src={signature?.logoURL}
              alt="Firm Logo"
              style={{ maxWidth: "auto", maxHeight: "45px" }}
            />
          )}
        </div>
      )}

      {/* User Name and Title (if not default) */}
      {signature.userId && (
        <div style={{ marginBottom: "5px" }}>
          <div style={{ fontWeight: "700", color: "var(--primary)", fontSize: "14px" }}>
            {signature.userName}
          </div>
          {signature.userTitle && <div style={{ fontSize: "14px" }}>{signature.userTitle}</div>}
        </div>
      )}

      {/* Firm Name */}
      <div style={{ fontWeight: "600", marginBottom: "5px" }}>{signature.firmName}</div>

      {/* Address */}
      <div style={{ fontWeight: "600" }}>
        {signature.address1}
        {signature.address2 && `, ${signature.address2}`}
      </div>
      <div style={{ fontWeight: "600" }}>
        {signature.city && `${signature.city},`} {signature.state && `${signature.state}`}{" "}
        {signature.zip}
      </div>

      {/* Contact Info */}
      <div style={{ marginTop: "5px", fontWeight: "600" }}>
        <div className="d-flex">
          <div style={{ paddingRight: "30px" }}>
            {signature.phone_number}{" "}
            <strong
              style={{
                color: "var(--primary-25)",
              }}
            >
              {signature.phone_extension ? `x ${signature.phone_extension}` : "phone"}
            </strong>
          </div>

          <div>
            {signature.fax}{" "}
            <strong
              style={{
                color: "var(--primary-25)",
              }}
            >
              fax
            </strong>
          </div>
        </div>
        <div>
          <a href={`mailto:${signature.email}`} style={{ color: "var(--primary)" }}>
            {signature.email}
          </a>
        </div>

        <div>
          <a
            href={`https://${signature.website}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "var(--primary)" }}
          >
            {signature?.website}
          </a>
        </div>
      </div>
    </div>
  );
};

export default SignaturePreview;
